export default __webpack_public_path__ + "static/media/green-circle-white-tick.1fdd82f0.svg";